module.exports = __webpack_public_path__ + "static/img/dfs_first.fc13a63e.png";